import { CdkMenuTrigger } from '@angular/cdk/menu';
import { afterNextRender, Component, inject, output, TemplateRef, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SonaIconComponent } from '@sona/angular-ui-components';
import { SonaLanguagePipe, useLanguage } from '@sona/angular-util-common';
import { BrnMenuTriggerDirective } from '@spartan-ng/ui-menu-brain';
import {
    HlmMenuComponent,
    HlmMenuGroupComponent,
    HlmMenuItemIconDirective,
    HlmMenuItemRadioComponent,
    HlmMenuItemRadioDirective
} from '@spartan-ng/ui-menu-helm';

@Component({
    selector: 'button[sonaLanguageMenu]',
    exportAs: 'sonaLanguageMenu',
    imports: [
        HlmMenuComponent,
        HlmMenuGroupComponent,
        HlmMenuItemRadioComponent,
        HlmMenuItemRadioDirective,
        SonaLanguagePipe,
        TranslateModule,
        HlmMenuItemIconDirective,
        SonaIconComponent
    ],
    templateUrl: './language-menu.component.html',
    hostDirectives: [{
        directive: BrnMenuTriggerDirective
    } ]
})
export class SonaLanguageMenuComponent {
    readonly onLanguageUpdate = output<string>();
    readonly selectedLanguage = useLanguage();
    protected readonly languageMenuTemplate = viewChild.required('languageMenu', { read: TemplateRef});
    protected readonly languages = [ 'de', 'en' ];

    constructor() {
        const trigger = inject(CdkMenuTrigger);

        afterNextRender(() => {
            trigger.menuTemplateRef = this.languageMenuTemplate();
        })
    }

    changeLanguage(language: string) {
        this.selectedLanguage.set(language);
        this.onLanguageUpdate.emit(language);
    }
}
